import React from 'react';
import { Col, Row, Form, FormGroup, FormControl, ButtonGroup, InputGroup, Button } from 'react-bootstrap';
import Select from 'react-select';
import constants from '../../util/constants';
import axios from 'axios';
import LoadingSpinner from '../../LoadingSpinner/index'
import './style.scss';


const { API_BASE_URL } = constants;


const allocationOptions = [
    {
        label: 'Customer',
        value: 0
    },
    {
        label: 'Agent',
        value: 1
    }
]

export default class CustomerReservation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allocationSettings: {
                Active: true,
                Period: -1,
                Allocation: -1,
                Overdraft: 0,
                MinItemWeight: 0
            },
            PeriodOptions: [],
            OverdraftValid: true,
            ccr: this.props.ccr,
            header: this.props.header,
            isLoading: false,
            save: {
                isError: false,
                hasSaved: false,
                text: ''
            }
        }

        this.handleActiveChange = this.handleActiveChange.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
        this.handleAllocationChange = this.handleAllocationChange.bind(this);
        this.handleOverdraftChange = this.handleOverdraftChange.bind(this);
        this.isOkToSave = this.isOkToSave.bind(this);
        this.getWrapperForSave = this.getWrapperForSave.bind(this);
        this.handleMinWeightChange = this.handleMinWeightChange.bind(this);
        this.getReservations = this.getReservations.bind(this);
    }

    async getReservations(ccr) {
        let customer = '?ccr=' + ccr;
        this.setState({ isLoading: true });
        axios.get(API_BASE_URL + 'CustomerProfile/GetCustomerReservation' + customer, { headers: this.state.header })
            .then((res) => {
                let data = res.data;
                let PeriodOptions = data.Periods && data.Periods.map((period) => {
                    return { label: period.PeriodName, value: period.PeriodId }
                })
                this.setState({ allocationSettings: data.OrderRules, PeriodOptions: PeriodOptions, isLoading: false })
            })
            .catch((error) => {
                console.log(error);
                this.setState({ isLoading: false });
            })
    }

    componentDidMount() {
        let ccr = this.state.ccr;
        if (ccr !== undefined) {
            this.getReservations(ccr);
        }
    }

    handleActiveChange() {
        let allocationSettings = this.state.allocationSettings;
        allocationSettings.Active = !allocationSettings.Active;
        this.setState(allocationSettings)
    }

    handlePeriodChange(evt) {
        let allocationSettings = this.state.allocationSettings;
        allocationSettings.Period = evt.value;
        this.setState(allocationSettings);
    }

    handleAllocationChange(evt) {
        let allocationSettings = this.state.allocationSettings;
        allocationSettings.Allocation = evt.value;
        this.setState(allocationSettings);
    }

    handleOverdraftChange(evt) {
        let { allocationSettings, OverdraftValid } = this.state;
        OverdraftValid = evt.target.validity.valid;
        allocationSettings.Overdraft = evt.target.value;
        this.setState({ allocationSettings: allocationSettings, OverdraftValid: OverdraftValid });

    }

    handleMinWeightChange(evt) {
        let { allocationSettings, OverdraftValid } = this.state;
        OverdraftValid = evt.target.validity.valid;
        allocationSettings.MinItemWeight = evt.target.value;
        this.setState({ allocationSettings: allocationSettings, OverdraftValid: OverdraftValid });
    }

    isOkToSave() {
        let { Period, Allocation } = this.state.allocationSettings;
        let result = Period !== -1 && Allocation !== -1 && this.state.OverdraftValid;
        return result;
    }

    getWrapperForSave() {
        return { OrderRules: this.state.allocationSettings }
    }

    saveSettings() {
        let wrapper = this.getWrapperForSave();
        this.setState({ save: { isError: false, hasSaved: true, isSaving: true, text: '' } })
        axios.post(API_BASE_URL + '/CustomerProfile/SaveCustomerReservation', wrapper, { headers: this.state.header })
            .then((res) => {
                this.setState({ save: { isError: false, hasSaved: true, text: 'Successfully saved settings' } })
            })
            .catch((error) => {
                this.setState({ save: { isError: true, hasSaved: true, text: 'Unable to save settings' } })
            })
    }

    render() {
        let chosenPeriod = this.state.PeriodOptions.find((period) => period.value === this.state.allocationSettings.Period)
        let chosenAllocation = allocationOptions.find((allocation) => allocation.value === this.state.allocationSettings.Allocation)

        return (
            this.state.isLoading
                ? <LoadingSpinner isLoading={true} />
                :
                <Form horizontal autoComplete='off' onSubmit={evt => { evt.preventDefault(); }} >
                    <Col sm={12}>
                        <Row><legend className="mylegend allocationLegend">Order reservation rules</legend></Row>
                        {this.props.ccr && <div>
                            <Row>
                                <Col sm={2}>
                                    <FormGroup className='select'>
                                        <ButtonGroup className="np-radio-wrapper margin-top-4" toggle="toggle">
                                            <InputGroup.Addon>On/Off</InputGroup.Addon>
                                            <div style={{ height: '38px' }} className="np-switch-wrapper">
                                                <span className="np-switch" style={{ height: '38px' }}>
                                                    <input type="checkbox"
                                                        style={{ height: '38px' }}
                                                        checked={this.state.allocationSettings.Active}
                                                        readOnly
                                                    />
                                                    <span style={{ height: '38px' }} className="slider" onClick={() => this.handleActiveChange()}></span>
                                                </span>
                                            </div>
                                        </ButtonGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row> <legend className='myLegend dataLegend'>Order rules</legend></Row>
                            <Row>
                                <FormGroup className='select'>
                                    <Col sm={2} >
                                        <InputGroup>
                                            <InputGroup.Addon>Min. order weight&nbsp;(tonn)</InputGroup.Addon>
                                            <FormControl type="number" required step="0.1" min="0" value={this.state.allocationSettings.MinItemWeight} placeholder="Minimum weight per item" onChange={(evt) => this.handleMinWeightChange(evt)} />
                                        </InputGroup>
                                    </Col>
                                </FormGroup>
                            </Row>
                            <Row><legend className='myLegend dataLegend'>Allocation rules</legend></Row>
                            <Row>
                                <FormGroup className='select'>
                                    <Col sm={2}>
                                        <InputGroup>
                                            <InputGroup.Addon>Period</InputGroup.Addon>
                                            <Select isSearchable={true} resetValue=''
                                                options={this.state.PeriodOptions}
                                                value={chosenPeriod}
                                                onChange={this.handlePeriodChange}
                                                placeholder="Timespan.."

                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col sm={2}>
                                        <InputGroup>
                                            <InputGroup.Addon>Allocation</InputGroup.Addon>
                                            <Select isSearchable={true} resetValue=''
                                                options={allocationOptions}
                                                value={chosenAllocation}
                                                onChange={this.handleAllocationChange}
                                                placeholder="Used for reservation"
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col sm={2}>
                                        <InputGroup>
                                            <InputGroup.Addon>Overdraft %</InputGroup.Addon>
                                            <FormControl type="number" required value={this.state.allocationSettings.Overdraft} placeholder="0" onChange={(evt) => this.handleOverdraftChange(evt)} />
                                        </InputGroup>
                                    </Col>
                                </FormGroup>
                            </Row >
                        </div>}
                    </Col>
                    <Col sm={12}>
                        {this.props.ccr &&
                            <Row className='flex-row-reverse'>
                                <Button bsStyle='primary' disabled={!this.isOkToSave()} onClick={() => this.saveSettings()}>Save</Button>
                                {this.state.save.hasSaved
                                    ? <b style={{ paddingLeft: '15px', color: this.state.save.isError ? 'red' : 'black' }}>{this.state.save.text}</b>
                                    : null}
                            </Row>
                        }
                    </Col>
                </Form>
        )
    }
}